import styled, { css } from 'styled-components';

const textStyles = css`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 14px;
  line-height: 21px;
`;

export const Title = styled.h1`
  font-weight: 600;
  ${textStyles}
`;

export const Content = styled.div`
  ${textStyles}
  max-height: 70vh;
  overflow-y: auto;
`;

export const Divider = styled.div`
  margin: 24px 0;
  border-top: 1px solid ${(props) => props.theme.colors['neutral-30']};
`;

export const SectionTitle = styled.p`
  margin-bottom: 24px;
  line-height: 16px;
  font-size: 14px;
  font-weight: 600;
  color: rgb(111, 113, 117);
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Footer = styled.div`
  display: flex;
  justify-items: center;
  padding-bottom: 8px;
  padding-top: 24px;
  gap: 10px;
  justify-content: center;
`;
